module.exports = __webpack_public_path__ + "images/foo.gif";


//////////////////
// WEBPACK FOOTER
// ./ui/src/images/foo.gif
// module id = 1262
// module chunks = 0